import { render, staticRenderFns } from "./OutOfBoundariesMonitor.vue?vue&type=template&id=11d4965a"
import script from "./OutOfBoundariesMonitor.vue?vue&type=script&lang=ts"
export * from "./OutOfBoundariesMonitor.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports